<template>
  <generic-modal
    :title="$t('organization')"
    :buttons="buttons"
    ref="generic_modal"
    size="fullscreen"
  >
    <form>
      <div class="columns">
        <div class="column is-one-third">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.name" />
            </div>
          </div>
        </div>
        <div class="column" v-show="selected_node">
          <form>
            <div class="columns">
              <div class="column">
                <div class="field">
                  <generic-dropdown
                    :title="$t('staff member')"
                    :placeholder="$t('select one')"
                    :is_multiple="false"
                    url="/staff/member/catalog"
                    :display_function="display_function"
                    value_field="member_id"
                    @selected="staff_member_changed"
                    ref="staff_member_dropdown"
                  />
                  <!-- <label class="label">{{ $t("name") }}</label>
                  <div class="control">
                    <input
                      type="text"
                      class="input"
                      v-model="selected_node.name"
                    />
                  </div> -->
                </div>
              </div>
              <div class="column" v-if="selected_node">
                <div class="field">
                  <label class="label">{{ $t("title") }}</label>
                  <div class="control">
                    <input
                      type="text"
                      class="input"
                      v-model="selected_node.title"
                    />
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">{{ $t("save") }}</label>
                  <div class="control">
                    <div
                      class="button is-primary"
                      @click="set_node(selected_node)"
                    >
                      <span class="icon">
                        <i class="fa fa-save"></i>
                      </span>
                    </div>
                    <div
                      class="button is-danger"
                      @click="delete_node(selected_node)"
                    >
                      <span class="icon">
                        <i class="fa fa-trash"></i>
                      </span>
                    </div>
                    <div
                      class="button is-info"
                      @click="add_children(selected_node)"
                    >
                      <span class="icon">
                        <i class="fa fa-plus"></i>
                      </span>
                    </div>
                    <div
                      class="button is-danger"
                      @click="selected_node = undefined"
                    >
                      <span class="icon">
                        <i class="fa fa-times"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div ref="chart_container" style="width: 100%; height: 100%">:)</div>
    </form>
    <div>
      <div class="notification is-danger mt-5" v-if="error">
        <p v-html="error"></p>
      </div>
    </div>
    <node-modal ref="node_modal" @save="set_node" />
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  api_host,
  generate_error_message_text,
  get_currency_settings,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import VLazyImage from "v-lazy-image";
import "orgchart/dist/js/jquery.orgchart";
import "orgchart/dist/css/jquery.orgchart.min.css";
import NodeModal from "../node_modal/Index.vue";
import { v4 } from "uuid";
// import "orgchart/dist/js/jquery.orgchart";
// import "orgchart/dist/css/jquery.orgchart.min.css";

export default {
  name: "OrganizationModal",
  components: {
    GenericModal,
    GenericUploader,
    VLazyImage,
    GenericDropdown,
    NodeModal,
  },
  data() {
    let v = this;
    return {
      selected_node: undefined,
      api_host,
      buttons: [
        {
          text: this.$t("save"),
          class: "is-primary is-rounded",
          icon: "fa fa-save",
          click: this.save,
          disabled: "this.is_form_invalid",
        },
        {
          text: this.$t("cancel"),
          class: "is-rounded",
          icon: "fa fa-close",
          click: this.close_modal,
        },
      ],
      meta: {},
      error: "",
      // uuid: "",
      ds: {},
      _default: {
        id: v4(),
        name: v.$t("name"),
        title: v.$t("title"),
        children: [],
      },
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name;
    },
  },
  methods: {
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
      v.ds = v._default;
      v.init_chart();
    },
    edit_modal(organization_uuid) {
      let v = this;
      v.set_initial_state();
      v.organization_uuid = organization_uuid;
      get("/staff/organization", { uuid: organization_uuid })
        .then((response) => {
          v.meta = response;
          if (response.settings && response.settings.org_data) {
            v.ds = response.settings.org_data;
            v.init_chart();
          }
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$refs.generic_modal.show_modal();
        });
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      data.settings.org_data = v.oc.getHierarchy(true);
      if (!v.organization_uuid) {
        put("/staff/organization", data)
          .then(() => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {
            v.selected_node = undefined;
          });
      } else {
        post("/staff/organization", data)
          .then(() => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {
            v.selected_node = undefined;
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
      v.selected_node = undefined;
      v.organization_uuid = "";
      v.$refs.staff_member_dropdown.clear();
      v.ds = {};
      // v.uuid = "";
    },
    init_chart() {
      let vm = this;
      window.jQuery(vm.$refs.chart_container).empty();
      let oc = window.jQuery(vm.$refs.chart_container).orgchart({
        data: vm.ds,
        nodeContent: "title",
        chartClass: "edit-state",
        draggable: false,
        pan: true,
        direction: "l2r",
        zoom: true,
        createNode: function (element, node) {
          // console.log("createNode", element, node);
          // if (
          //   !node.user ||
          //   (!node.auto_evaluation_template_id &&
          //     !node.inferior_evaluation_template_id &&
          //     !node.same_level_evaluation_template_id &&
          //     !node.superior_evaluation_template_id)
          // ) {
          //   element.addClass("red");
          // }
        },
      });

      oc.$chartContainer.on("touchmove", function (event) {
        event.preventDefault();
      });

      oc.$chartContainer.on("click", ".node", function (event) {
        // // console.log("selected node");
        event.preventDefault();
        event.stopPropagation();
        let $this = window.jQuery(this);
        let data = $this.data("nodeData");
        // console.log("selected node", data);
        // vm.$refs.node_modal.show_modal(data, vm.ds);
        vm.selected_node = data;

        if (data.otherPro && data.otherPro.member_id)
          vm.$refs.staff_member_dropdown.set_value(data.otherPro.member_id);

        // vm.$refs.sidebar.show(data, vm.ds);
      });

      oc.$chartContainer.on("click", ".orgchart", function () {
        // console.log("selected orgchart");
        // window.jQuery(".ui.sidebar").sidebar("hide");
      });

      vm.oc = oc;
    },
    set_node(data) {
      let v = this;
      let node = v.get_node(data, v.ds);
      if (node) {
        node.name = data.name;
        node.title = data.title;
        node.otherPro = { member_id: data.member_id };
        v.init_chart();
        // vm.oc.updateNode(node);
      }
      v.selected_node = undefined;
      // if (node) {
      //   node[0].name = data.name;
      //   node[0].title = data.title;
      //   vm.oc.addChildren(node[0], data.children);
      //   vm.oc.updateNode(node[0]);
      // } else {
      //   vm.oc.addChildren(data.parent, [data]);
      // }
    },
    get_node(node, ds) {
      let v = this;
      if (ds.id === node.id) {
        return ds;
      } else {
        if (ds.children) {
          for (let i = 0; i < ds.children.length; i++) {
            let n = v.get_node(node, ds.children[i]);
            if (n) return n;
          }
        }
      }
    },
    delete_node(data) {
      let v = this;
      let newds = { ...v.oc.getHierarchy(true) };
      let t = v.delete_tree_node(newds, data);
      v.ds = v.check_nodes(t);
      v.selected_node = undefined;
      setTimeout(() => {
        v.init_chart();
      }, 200);
    },
    check_nodes(tree) {
      let v = this;
      if (tree.children) {
        tree.children = tree.children
          .filter((c) => c)
          .map((child) => v.check_nodes(child));
      }
      return tree;
    },
    staff_member_changed(staff_member) {
      let v = this;
      if (v.selected_node && staff_member) {
        v.selected_node.name = `${staff_member.first_name} ${staff_member.first_surname}`;
        v.selected_node.member_id = staff_member.member_id;
      }
    },
    display_function(data) {
      return `${data.first_name} ${data.first_surname}`;
    },
    add_children(data) {
      let v = this;
      let node = v.get_node(data, v.ds);
      if (node) {
        node.children = node.children || [];
        node.children.push({
          id: v4(),
          name: "",
          title: "",
          children: [],
        });
        v.selected_node = undefined;
        v.init_chart();
      }
    },
    delete_tree_node(tree, node) {
      let v = this;
      if (tree.id === node.id) {
        tree = {};
        return;
      } else {
        if (tree.children) {
          tree.children = tree.children.map((child) =>
            v.delete_tree_node(child, node)
          );
        }
        return tree;
      }
    },
  },
  mounted() {},
  created() {},
  watch: {
    is_form_invalid() {
      let v = this;
      v.buttons[0].disabled = v.is_form_invalid;
    },
    selected_node() {
      let v = this;
      if (v.selected_node) {
        v.$refs.staff_member_dropdown.clear();
      }
    },
  },
};
</script>
<style>
.hierarchy > .node > .content {
  margin-top: -24px;
}
</style>
